<template>
  <div class="giveaway-card">
    <a class="d-flex align-center text-decoration-none" :href="gives.giveaway_image" target="_blank">
    <Avatar borderRadius="square" :avatar="gives.giveaway_image"/>
    <span class="giveaway-card__name ml-3">
      {{ gives.giveaway_name }}
    </span>
    </a>
  </div>

</template>

<script>
import Avatar from "@/components/Avatar.vue";
import Image from "@/components/Chat/parts/Image.vue";

export default {
  components: {Image, Avatar},
  props: {
    gives: {
      type: Object,
      default: () => ({})
    }
  }
}

</script>



<style lang="scss">
.giveaway-card{
  display: flex;
  align-items: center;
  font-family: 'Inter', sans-serif;
  border: 1px solid #e2e2e2;
  padding: 12px;
  border-radius: 8px;
  width: 100%;
  background-color: #ffffff;
  &__name{
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: 0;
    color: var(--username-category-title);

  }
}

</style>